export enum QuestionTypes {
  CHECKBOX = "CHECKBOX",
  TEXT = "TEXT",
  RADIO_YES_OR_NO = "RADIO_YES_OR_NO",
  CHECKBOX_YES_OR_NO = "CHECKBOX_YES_OR_NO",
  GROUP = "GROUP"
}
